export const CLIENT_PROTOCOL_VERSION = "0.1.0";
export class BrowserRegistry {
    static state(create = true) {
        if (typeof window === "undefined")
            return undefined;
        if (window.__gsb !== undefined) {
            if (window.__gsb === null ||
                window.__gsb.version !== CLIENT_PROTOCOL_VERSION ||
                typeof window.__gsb.slots !== "object" ||
                window.__gsb.slots === null) {
                throw new Error("Incompatible GSB browser registry version.");
            }
            return window.__gsb;
        }
        if (!create)
            return undefined;
        const state = Object.freeze({
            version: CLIENT_PROTOCOL_VERSION,
            slots: {},
        });
        Object.defineProperty(window, "__gsb", {
            value: state,
            writable: false,
            configurable: false,
        });
        return state;
    }
    static lookup(key) {
        return this.state(false)?.slots[key];
    }
    static register(key, value) {
        const state = this.state();
        if (!state)
            return;
        const existing = state.slots[key];
        if (existing !== undefined) {
            if (existing !== value)
                throw new Error(`GSB browser registry overwrite rejected: ${key}.`);
            return;
        }
        Object.defineProperty(state.slots, key, {
            value,
            enumerable: true,
            writable: false,
            configurable: false,
        });
    }
    static acquire(key, create) {
        const existing = this.lookup(key);
        if (existing !== undefined && existing !== null)
            return existing;
        const value = create();
        this.register(key, value);
        return value;
    }
}
//# sourceMappingURL=registry.js.map